import {ComposedChart, Legend, Tooltip, Line, ResponsiveContainer, XAxis, YAxis} from 'recharts'
import useQueryBalanceTimeline from '../../../hooks/api/unknownorder/useQueryBalanceTimeline'
import ContainerLayout from '../../../components/layout/ContainerLayout'
import {useEffect, useMemo} from 'react'
import {useTime} from '../../../utils/time'
import moment from 'moment'

interface IProps {
    className?: string
    orderID?: string
}

interface IDiffGraph {
    balance?: number
    order?: number
    timestamp?: string | number
}

const BalanceTimeLine: React.FC<IProps> = ({className, orderID}) => {
    const {data, refetch} = useQueryBalanceTimeline(orderID)

    const diffCheckList = useMemo(() => {
        let list = []
        if (data?.balance === undefined || data?.order === undefined) {
            return list
        }

        const tempb = data.balance.map<IDiffGraph>(el => {
            return {timestamp: el.timestamp, balance: el.amount}
        })
        const tempo = data.order.map<IDiffGraph>(el => {
            return {timestamp: el.timestamp, order: el.amount}
        })

        list.push(...tempb, ...tempo)
        list.sort((a, b) => {
            return a.timestamp - b.timestamp
        })

        return list.map(el => {
            let t = moment.unix(el.timestamp)
            return {
                ...el,
                timestamp: t.utc().local().format('YYYY/MM/DD HH:mm:ss'),
            }
        })
    }, [data])

    useEffect(() => {
        refetch()
    }, [])

    return (
        <>
            <div>
                <ContainerLayout title={'diff check line'}>
                    <ResponsiveContainer width="100%" height={400}>
                        <ComposedChart
                            syncId={'cd'}
                            margin={{top: 5, right: 30, left: 20, bottom: 5}}
                            data={diffCheckList}>
                            <XAxis dataKey="timestamp" />
                            <YAxis orientation="left" />
                            <Legend />
                            <Tooltip />
                            <Line
                                connectNulls
                                dot={<div></div>}
                                type="monotone"
                                dataKey={'balance'}
                                strokeWidth={1}
                                activeDot={{r: 3}}
                            />
                            <Line
                                connectNulls
                                dot={<div></div>}
                                type="monotone"
                                dataKey={'order'}
                                stroke="#FFA500"
                                strokeWidth={1}
                                activeDot={{r: 3}}
                            />
                        </ComposedChart>
                    </ResponsiveContainer>
                </ContainerLayout>
            </div>
        </>
    )
}

export default BalanceTimeLine
